import React from "react";
import { Redirect, Route } from "react-router";

/* eslint no-console: off */
export function WrongRoute({ path, to }) {
    return (
        <Route
            path={path}
            render={() => {
                return <Redirect to={to} />
            }}
        />
    );
}
